import Modal from "react-modal";
import { useState } from "react";
import Select from "react-select";
import { POSITION, AREA } from "../utils/constants";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "../App.css";
const initialData = {
  name: null,
  company: null,
  email: null,
  phone: null,
  position: null,
  area: null,
};
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    padding: "0px",
    borderRadius: "8px",
    border: "none",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    zIndex: 30,
  },
  overlay: {
    backgroundColor: " rgba(0,0,0,0.5)",
    zIndex: 30,
  },
};
function Form({ modalIsOpen, openModal, closeModal, t, number }) {
  const [status, setStatus] = useState("none");
  const [formData, setFormData] = useState(initialData);
  const handleInputChange = (e) => {
    const { label, value } = e;
    setFormData({
      ...formData,
      [label]: value,
    });
  };

  async function onSubmit(event) {
    formData.name = event.target[0].value;
    formData.company = event.target[1].value;
    formData.email = event.target[2].value;
    event.preventDefault();
    if (
      !event.target[0].value ||
      !event.target[1].value ||
      !event.target[2].value ||
      !formData.phone ||
      !formData.position ||
      !formData.area
    ) {
      return "";
    }
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var raw = JSON.stringify({...formData,type_register:modalIsOpen.title});
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    setStatus("sending");
    try {
      const responseb = await fetch(
        "https://api2.shelf-e.com:9080/api/form",
        requestOptions,
      );
      if (responseb.status === 404) {
        setStatus("error4");
      } else if (!responseb.ok) {
        setStatus("error4");
      } else {
        const response = await responseb.json();
        setTimeout(() => setStatus("success"), 500);
      }
    } catch (e) {
      setStatus("error4");
    }
  }
  return (
    <Modal
      isOpen={modalIsOpen.state}
      onRequestClose={closeModal}
      onAfterClose={() => {
        setStatus("none");
      }}
      style={customStyles}
      contentLabel="Example Modal"
    >
      {" "}
      <div
        className="app-modal-header"
        style={{
          backgroundColor:
            status == "none"
              ? "#21BFDB"
              : status == "error" || status == "error4"
                ? "#D75A4A"
                : "#25AE88",
        }}
      ></div>
      <section className="u-align-center u-clearfix u-section-7" id="sec-ea05">
        <div className="u-clearfix u-valign-middle u-sheet-1">
          {status == "none" ? (
            <h3 className="u-text u-align-center u-text-palette-1-base u-text-1">
              {modalIsOpen.title}
            </h3>
          ) : (
            <></>
          )}

          {status == "none" ? (
            <div className="u-form u-form-1">
              <form
                onSubmit={onSubmit}
                className="u-clearfix u-form-spacing-10 u-form-vertical u-inner-form"
                style={{ padding: "10px" }}
                name="form"
              >
                <div className="u-form-group u-form-name u-label-top">
                  <label htmlFor="name-3b9a" className="u-label">
                    {t("form_2")}
                  </label>
                  <input
                    type="text"
                    id="name-3b9a"
                    name="name"
                    className="u-input u-input-rectangle"
                    required="required"
                  />
                </div>
                <div className="u-form-group u-label-top u-form-group-2">
                  <label htmlFor="text-fd54" className="u-label">
                    {t("form_3")}
                  </label>
                  <input
                    type="text"
                    placeholder=""
                    id="text-fd54"
                    name="company"
                    className="u-input u-input-rectangle"
                    required="required"
                  />
                </div>
                <div className="u-form-email u-form-group u-label-top">
                  <label htmlFor="email-3b9a" className="u-label">
                    {t("form_4")}
                  </label>
                  <input
                    type="email"
                    id="email-3b9a"
                    name="email"
                    className="u-input u-input-rectangle"
                    required="required"
                  />
                </div>
                <div className="u-form-group u-form-phone u-label-top u-form-group-4">
                  <label htmlFor="phone-0741" className="u-label">
                    {t("form_5")}
                  </label>
                  <PhoneInput
                    required="required"
                    inputStyle={{ width: "100%" }}
                    value={formData.phone}
                    onChange={(e) =>
                      handleInputChange({ label: "phone", value: e })
                    }
                    country={"mx"}
                    name="phone"
                  />
                </div>
                <div className="u-form-group u-form-select u-label-top u-form-group-5">
                  <label htmlFor="select-f818" className="u-label">
                    {t("form_6")}
                  </label>
                  <div className="custom-select">
                    <Select
                      required="required"
                      id="select-f818"
                      menuPosition="absolute"
                      menuPlacement="top"
                      onChange={(e) =>
                        handleInputChange({ label: "position", value: e.value })
                      }
                      isSearchable={true}
                      options={POSITION[number]}
                      placeholder={t("form_7")}
                      name="position"
                    />
                  </div>
                </div>
                <div className="u-form-group u-form-select u-label-top u-form-group-6">
                  <label htmlFor="select-5b1f" className="u-label">
                    {t("form_8")}
                  </label>
                  <div className="custom-select">
                    <Select
                      required="required"
                      id="select-5b1f"
                      menuPosition="absolute"
                      menuPlacement="top"
                      onChange={(e) =>
                        handleInputChange({ label: "area", value: e.value })
                      }
                      isSearchable={true}
                      options={AREA[number]}
                      placeholder={t("form_7")}
                      name="area"
                    />
                  </div>
                </div>
                <div className="u-align-center u-form-group u-form-submit u-label-top">
                  <button
                    type="submit"
                    className="u-border-none u-btn u-btn-round u-btn-submit u-button-style u-hover-palette-1-dark-1 u-palette-1-base u-radius-50 u-btn-1"
                  >
                    {t("button_3")}
                  </button>
                </div>
              </form>
            </div>
          ) : status == "sending" ? (
            <div className="loading">
              <img
                alt="loading_icon"
                src="/images/loading.gif"
                width={50}
                height={50}
                style={{ marginBottom: 10 }}
              />
              <h6 className="u-align-center u-text u-text-palette-2-base u-text-7">
                {t("form_9")}
              </h6>
            </div>
          ) : status == "error" || status == "error4" ? (
            <div className="loading">
              <img
                alt="warning_icon"
                src="/images/warning.svg"
                width={50}
                height={50}
                style={{ marginBottom: 20 }}
              />
              <h6 className="u-align-center u-text u-text-palette-2-base u-text-7">
                {status == "error" ? t("form_10") : t("form_14")}
                <br />
                {status == "error" ? t("form_11") : t("form_15")}
              </h6>
            </div>
          ) : (
            <div className="loading">
              <img
                src="/images/success.svg"
                width={50}
                height={50}
                style={{ marginBottom: 20 }}
              />
              <h6 className="u-align-center u-text u-text-palette-2-base u-text-7">
                {t("form_12")}
                <br /> {t("form_13")}
              </h6>
            </div>
          )}
        </div>
      </section>
    </Modal>
  );
}

export default Form;

